import { Component, OnInit, signal } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { ImportService } from '../import.service';
import * as fromShared from '../../shared';
import { Observable } from 'rxjs';
import { Message } from '../../shared';
import { getSettingBooleanValue } from '../../company-setting';
import * as fromSettings from '../../company-setting';

@Component({
    selector: 'ef-import-container',
    templateUrl: './import-container.component.html',
    styleUrls: ['./import-container.component.scss'],
    standalone: false
})
export class ImportContainerComponent implements OnInit {
    constructor(
        private service: ImportService,
        private log: LoggingService,
        private store: Store
    ) {}
    public IsLoading = false;
    public message = '';
    public messages: fromShared.ToastMessageOptions[] = [];
    //public messages = signal<any[]>([]);
    process$: Observable<fromShared.Process>;
    public includeInactive$: Observable<boolean>;
    ngOnInit(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.includeInactive$ = this.store.pipe(
            select(getSettingBooleanValue('GovConPayImportInactiveEmployees'))
        );
        //dispatch
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'GovConPayImportInactiveEmployees'
            })
        );
    }
    onStartImport(includeInactive: boolean): void {
        //log
        this.log.verbose({
            type: 'ImportContainerComponent',
            message: 'onStartImport',
            includeInactive
        });
        // call the import API
        this.IsLoading = true;
        this.message = 'Importing...';
        this.messages = [
            {
                severity: 'info',
                summary: 'Importing...'
            }
        ];
        this.service
            .LoadData(includeInactive)
            .then(() => {
                this.message = 'Import Complete';
                this.messages = [
                    {
                        severity: 'success',
                        summary: 'Import Complete'
                    }
                ];
                this.store.dispatch(
                    fromSettings.putCompanySettings({
                        settings: [
                            {
                                SettingType: 'GovConPayImportInactiveEmployees',
                                SettingValue: false
                            }
                        ]
                    })
                );
            })
            .catch(reason => {
                this.log.error({ type: 'ImportContainerComponent', reason });
                this.message = 'Import Failed';
                this.messages = [
                    {
                        severity: 'error',
                        summary: 'Import Failed'
                    }
                ];
            })
            .finally(() => (this.IsLoading = false));
    }
    onSetIncludeInactive(includeInactive: boolean): void {
        this.log.verbose({
            type: 'ImportContainerComponent',
            message: 'onSetIncludeInactive',
            includeInactive
        });
        this.store.dispatch(
            fromSettings.putCompanySettings({
                settings: [
                    {
                        SettingType: 'GovConPayImportInactiveEmployees',
                        SettingValue: includeInactive
                    }
                ]
            })
        );
    }
}
